import React, { useState } from 'react';
import PromoBar from '../components/PromoBar';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import BalayageStyles from '../components/BalayageStyles';
import Gallery from '../components/Gallery';
import Team from '../components/Team';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = () => {
  const [isPromoVisible, setIsPromoVisible] = useState(true);

  return (
    <div className={`min-h-screen ${isPromoVisible ? 'pt-12' : 'pt-0'}`}>
      <PromoBar isVisible={isPromoVisible} onClose={() => setIsPromoVisible(false)} />
      <Header />
      <Hero />
      <About />
      <Services />
      <BalayageStyles />
      <Gallery />
      <Team />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
